var AssessmentsSyncMessageController = /** @class */ (function () {
    /*@ngInject*/
    function AssessmentsSyncMessageController($state, utilityService, sharedAjsService) {
        this.$state = $state;
        this.utilityService = utilityService;
        this.sharedAjsService = sharedAjsService;
    }
    AssessmentsSyncMessageController.prototype.$onInit = function () {
        this.showSyncMessage = false;
        this.displayNavigationToAssessments = false;
        this.listenToAssessmentsSync();
    };
    AssessmentsSyncMessageController.prototype.listenToAssessmentsSync = function () {
        var _this = this;
        this.sharedAjsService.receiveAssessmentsSyncMessage().then(null, null, function (message) {
            _this.displayNavigationToAssessments = !message.includes('Syncing Assessments');
            if (_this.displayNavigationToAssessments) {
                _this.syncMessage = message + " Go to Assessments";
            }
            else {
                _this.syncMessage = message;
            }
            _this.showSyncMessage = true;
        });
    };
    AssessmentsSyncMessageController.prototype.goToAssessments = function () {
        if (this.$state.current.name === 'missioncontrol.assessmentManagement') {
            this.$state.reload();
        }
        else {
            this.$state.go('missioncontrol.assessmentManagement', { reload: true });
        }
        this.showSyncMessage = false;
    };
    return AssessmentsSyncMessageController;
}());
AssessmentsSyncMessageController.$inject = ['$state', 'utilityService', 'sharedAjsService'];
// import * as TEMPLATE from './user-header.html';
import * as TEMPLATE from 'raw-loader!./assessments-sync-message.html';
export var AssessmentsSyncMessageComponent = {
    selector: 'assessmentsSyncMessage',
    component: {
        controller: AssessmentsSyncMessageController,
        // templateUrl: 'app/components/assessmentsSyncMessage/assessments-sync-message.html'
        template: TEMPLATE.default
    }
};
//# sourceMappingURL=assessments-sync-message.component.js.map